import apiClient from '../../../lib/apiClient';

const manualEditorService = {
  async generateDesign(payload) {
    return apiClient.request('/design/generate', {
      method: 'POST',
      body: JSON.stringify(payload)
    });
  },

  async listDesigns(sessionId) {
    const suffix = sessionId ? `?session_id=${encodeURIComponent(sessionId)}` : '';
    return apiClient.request(`/designs${suffix}`, { auth: Boolean(!sessionId) });
  },

  async getDesign(id) {
    return apiClient.request(`/designs/${id}`);
  },

  async updateCanvas(id, canvasJson) {
    return apiClient.request(`/designs/${id}/canvas`, {
      method: 'PUT',
      body: JSON.stringify({ canvas_json: canvasJson })
    });
  },

  async duplicate(id) {
    return apiClient.request(`/designs/${id}/duplicate`, { method: 'POST' });
  },

  async destroy(id) {
    return apiClient.request(`/designs/${id}`, { method: 'DELETE' });
  },

  async searchMedia(query, mediaType = 'photo', orientation = '') {
    const params = new URLSearchParams();
    params.set('q', query || 'marketing creative inspiration');
    params.set('type', mediaType || 'photo');
    params.set('page', '1');
    if (orientation) {
      params.set('orientation', orientation);
    }

    return apiClient.request(`/media/search?${params.toString()}`, { auth: false });
  },
};

export default manualEditorService;
